import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { activeEnvironment, apiEndpoints } from "../../services/apiConfig";

// Async thunk to fetch user details
export const fetchUserDetails = createAsyncThunk(
  "user/fetchUserDetails",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        return rejectWithValue("No token found. Please login again.");
      }

      const response = await axios.get(apiEndpoints.getuserProfile, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // expected { user: {...} }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch user details"
      );
    }
  }
);

export const updateUserDetails = createAsyncThunk(
  "user/updateUserDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        return rejectWithValue("No token found. Please login again.");
      }

      const response = await axios.post(
        apiEndpoints.updateUserDetails,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.data; // return updated user data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update user details"
      );
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    details: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearUser: (state) => {
      state.details = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload;
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload; // update state with new details
      })
      .addCase(updateUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearUser } = userSlice.actions;
export default userSlice.reducer;
